import { Outlet, useLocation } from 'react-router-dom';
import './App.scss';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import BetaMessage from './components/BetaMessage/BetaMessage';
import { useState, useEffect } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  const [isNarrow, setIsNarrow] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const checkWidth = () => {
      setIsNarrow(window.innerWidth < 850);
    };

    checkWidth(); // check on mount
    window.addEventListener('resize', checkWidth);
    return () => window.removeEventListener('resize', checkWidth);
  }, []);

  // Don't show header on login page
  const hideHeader = location.pathname === '/login';

  return (
    <div className={`flex flex-col min-h-screen ${isNarrow ? 'pt-[80px]' : 'pt-[0px]'}`}>
      <BetaMessage />
      <div className="flex-1">
        {!hideHeader && <Header />}
        <Outlet />
      </div>
      <Footer />
      <ToastContainer />
    </div>
  );
}

export default App;
